export default __webpack_public_path__ + "static/media/HL_Biology.8ccc5242.svg";